import { useEffect } from "react";
import { getPage } from "../store/page";
import { AppState } from "../store";
import { connect, ConnectedProps } from "react-redux";

const ScrollToTop: React.FC<{} & PropsFromRedux> = (props) =>
{
    useEffect(() =>
    {
        if (props.page?._url)
        {
            window.scrollTo(0, 0);
        }
    }, [props.page?._url]);

    return null;
};

const mapStateToProps = (state: AppState) => ({
    page: getPage(state.page)
});

const connector = connect(
    mapStateToProps
);

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ScrollToTop);